import request from '@/utils/request'


// 查询订单产品列表
export function listOrderGoods(query) {
  return request({
    url: '/user/order-goods/list',
    method: 'get',
    params: query
  })
}

// 查询订单产品分页
export function pageOrderGoods(query) {
  return request({
    url: '/user/order-goods/page',
    method: 'get',
    params: query
  })
}

// 查询订单产品详细
export function getOrderGoods(data) {
  return request({
    url: '/user/order-goods/detail',
    method: 'get',
    params: data
  })
}

// 新增订单产品
export function addOrderGoods(data) {
  return request({
    url: '/user/order-goods/add',
    method: 'post',
    data: data
  })
}

// 修改订单产品
export function updateOrderGoods(data) {
  return request({
    url: '/user/order-goods/edit',
    method: 'post',
    data: data
  })
}

// 删除订单产品
export function delOrderGoods(data) {
  return request({
    url: '/user/order-goods/delete',
    method: 'post',
    data: data
  })
}
